const API_ROOT = 'https://app-node.itsecuritywire.com:3020';
const API_ROOTT= 'http://localhost:3020';
const webPath = 'https://itsecuritywire.com'

export { API_ROOT , webPath,API_ROOTT};